// extracted by mini-css-extract-plugin
export default {"wrapper":"viewer-language-switch_wrapper__YYe+L"};